import {NgModule} from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import {UsersService} from './users.service';
import {PublishersService} from './publishers.service';
import {PlaylistsService} from './playlists.service';
import {ChannelsService} from './channels.service';
import {VideosService} from './videos.service';
import {DashboardService} from './dashboard.service';
import {DomainsService} from './domains.service';
import {CategoriesService} from './categories.service';
import {KitchenService} from './kitchen.service';
import { DemandPartnersService } from './demand-partners.service';
import { PubDashService } from './pub-dash.service';
import { AppsService } from './apps.service';

@NgModule({ declarations: [],
    exports: [], imports: [], providers: [
        UsersService,
        PublishersService,
        PlaylistsService,
        ChannelsService,
        VideosService,
        DemandPartnersService,
        DashboardService,
        DomainsService,
        PubDashService,
        CategoriesService,
        KitchenService,
        AppsService,
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ] })
export class ServicesModule {
}
